import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';
import { navigateToApplicationUrl, resolveAppImpersonationHandoffUrl } from '@/shared/config';
import { isPlatformHost } from '@/shared/lib';

const isAuthRoute = (to: RouteLocationNormalized): boolean =>
  typeof to.name === 'string' && to.name.startsWith('auth.');

export const platformHostGuard = (to: RouteLocationNormalized): NavigationGuardReturn => {
  const platformRoute = to.meta.superuser === true;
  const platformHost = isPlatformHost(globalThis.window?.location.origin ?? '');

  if (platformHost) {
    const authStore = useAuthStore();
    const organizationId = authStore.impersonation.organization?.id;

    if (authStore.isImpersonating) {
      if (organizationId) {
        try {
          navigateToApplicationUrl(resolveAppImpersonationHandoffUrl(organizationId));
          return false;
        } catch {
          // Invalid build-time destination falls through to a stable local page.
        }
      }

      return isAuthRoute(to) ? true : { name: 'auth.platform-access-denied' };
    }

    return platformRoute || isAuthRoute(to) ? true : { name: 'platform.organizations' };
  }

  return platformRoute ? { name: 'home.index' } : true;
};
